import React, { useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import MetisMenu from "metismenujs"
import PropTypes from "prop-types"
import SimpleBar from "simplebar-react"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { UI_PERMISSION_KEY } from "pages/Roles/newFeaturesAndPermissionsData"
import Skeleton from "react-loading-skeleton"
import useFeatureFlags from "hooks/useFeatureFlags"
import useFeatureFlagsForAccounts from "hooks/useFeatureFlagsForAccounts"
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants"
import { useSelector } from "react-redux"
import { getPrimaryTextClass } from "helpers/sf_utils"
import usePlatformSettings from "hooks/usePlatformSettings"
import { AppConfiguration } from "config"
import { WHITE_LABELED_PRODUCT_NAMES } from "config"
import { bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper"
import { getIntegrationPermissions } from "helpers/sf_integration_permissions_helper"

const SidebarContent = props => {

  if (props?.loadings || !props?.rolePermissions) {
    return (
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled ms-2" id="side-menu">
          <li className="my-4 px-3">
            <Skeleton baseColor="#494E5E" highlightColor="#444" />
          </li>
          <li className="my-4 px-3">
            <Skeleton baseColor="#494E5E" highlightColor="#444" />
          </li>
          <li className="my-4 px-3">
            <Skeleton baseColor="#494E5E" highlightColor="#444" />
          </li>
          <li className="my-4 px-3">
            <Skeleton baseColor="#494E5E" highlightColor="#444" />
          </li>
          <li className="my-4 px-3">
            <Skeleton baseColor="#494E5E" highlightColor="#444" />
          </li>
          <li className="my-4 px-3">
            <Skeleton baseColor="#494E5E" highlightColor="#444" />
          </li>
          <li className="my-4 px-3">
            <Skeleton baseColor="#494E5E" highlightColor="#444" />
          </li>
          <li className="my-4 px-3">
            <Skeleton baseColor="#494E5E" highlightColor="#444" />
          </li>
        </ul>
      </div>
    )
  }

  const {
    current_account, current_brand, campaigns
  } = useSelector((state) => ({
    current_account: state.accounts.current_account,
    current_brand: state.Brands.current_brand,
  }));

  const ref = useRef()
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName.includes(items[i].pathname)) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  const [isFeatureFlagActive] = useFeatureFlags();
  const [isFeatureFlagActiveForAccounts] = useFeatureFlagsForAccounts();
  const { isClicksProductEnabled } = usePlatformSettings();
  // BM-9524: hide Integrations from roles without View/Manage Integrations (flag on only).
  const integrationPermissions = getIntegrationPermissions({
    flagOn: isFeatureFlagActiveForAccounts(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_INTEGRATION_ROLE_PERMISSIONS, current_account),
    isAdmin: bsh_isAdminUserDetailsPresent(),
    rolePermissions: props?.rolePermissions,
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled ms-2" id="side-menu">

            <li>
              <Link to="/dashboard">
                <>
                  <i className={`${getPrimaryTextClass()} bx bx-rocket`} />
                  <span>{props.t("Overview")}</span>
                </>
              </Link>
            </li>

            <li>
              <Link to="/analytics">
                <>
                  <i className={`${getPrimaryTextClass()} bx bx-chart`} />
                  <span>{props.t("Analytics")}</span>
                </>
              </Link>
            </li>

            {props?.rolePermissions?.find(singe_obj => singe_obj.ui_key === UI_PERMISSION_KEY.VIEW_CAMPAIGNS)?.isActive && (
              <li id='campaigns'>
                <Link to="/campaigns" className=" ">
                  <>
                    <i className={`${getPrimaryTextClass()} bx bxs-megaphone`} />
                    <span>{props.t("Campaigns")}</span>
                  </>
                </Link>
              </li>
            )}

            {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_LEADS_CALLS_IN_SIDEBAR) &&
              AppConfiguration.PRODUCT_NAME == WHITE_LABELED_PRODUCT_NAMES.GOAL ?
              (
                <li>
                  <Link to="/prospects" className=" ">
                    <i className={`${getPrimaryTextClass()} bx bx-conversation`} />
                    <span>{props.t("Prospects")}</span>
                  </Link>
                </li>
              )
              : (
                <>
                  <li hidden={!props?.campaigns?.lead && !props?.campaigns?.quote_funnels}>
                    <Link to="/leads" className=" ">
                      <>
                        <i className={`${getPrimaryTextClass()} bx bx-conversation`} />
                        <span>{props.t("Leads")}</span>
                      </>
                    </Link>
                  </li>
                  <li hidden={!props?.campaigns?.call && !props?.campaigns?.quote_funnels}>
                    <Link to="/calls" className=" ">
                      <>
                        <i className={`${getPrimaryTextClass()} bx bx-phone-call`} />
                        <span>{props.t("Calls")}</span>
                      </>
                    </Link>
                  </li>
                </>
              )}
            {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CPA_OPTIMIZER) && (
              <li hidden={!props?.campaigns?.lead && !props?.campaigns?.call}>
                <Link to="/cpa-optimizer" className=" ">
                  <>
                    <i className={`${getPrimaryTextClass()} bx bx-pie-chart-alt-2`} />
                    <span>{props.t("CPA Optimizer")}</span>
                  </>
                </Link>
              </li>
            )}
            {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CONVERSATION_AND_SUMMARY_TAB) && current_account?.call_summary_enabled && <li hidden={!props?.campaigns?.call && !props?.campaigns?.quote_funnels}>
              <Link to="/conversations" className=" ">
                <>
                  <i className={`${getPrimaryTextClass()} bx bx-chat`} />
                  <span>{props.t("Conversations")}</span>
                </>
              </Link>
            </li>}
            {props?.rolePermissions?.find(singe_obj => singe_obj.ui_key === UI_PERMISSION_KEY.MANAGE_CREATIVES)?.isActive && isClicksProductEnabled && (
              <li>
                <Link to="/creatives" className=" ">
                  <>
                    <i className={`${getPrimaryTextClass()} bx bx-palette`} />
                    <span>{props.t("Creatives")}</span>
                  </>
                </Link>
              </li>
            )}
            {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_QUOTE_FUNNELS) && <li>
              <Link to="/quote_funnels">
                <>
                  <i className={`${getPrimaryTextClass()} bx bx-filter`} />
                  <span>{props.t("Quote Funnel")}</span>
                </>
              </Link>
            </li>}

            {props?.rolePermissions?.find(singe_obj => singe_obj.ui_key === UI_PERMISSION_KEY.MANAGE_USER_MANAGEMENT)?.isActive && (
              <li>
                <Link to="/dashboard" className={props?.rolePermissions ? "has-arrow" : ""}>
                  <> <i className={`${getPrimaryTextClass()} bx bx-user`} />
                    <span>{props.t("Organization")}</span>
                  </>
                </Link>
                <ul aria-expanded="false">
                  <li>
                    <Link to="/users">
                      <span className="d-flex justify-content-between align-items-center">
                        <i className={`${getPrimaryTextClass()} bx bx-user-pin`} />
                        <span>{props.t("User Management")}</span>
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/roles">
                      <>
                        <i className={`${getPrimaryTextClass()} bx bx-book-content`} />
                        <span>{props.t("Roles")}</span>
                      </>
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {props?.rolePermissions?.find(singe_obj => singe_obj.ui_key === UI_PERMISSION_KEY.VIEW_BILLING)?.isActive && (
              <li>
                <Link to="/billings" className=" ">
                  <>
                    <i className={`${getPrimaryTextClass()} bx bx-credit-card`} />
                    <span>{props.t("Billing")}</span>
                  </>
                </Link>
              </li>
            )}

            <li>
              <Link to="/dashboard" className={props?.rolePermissions ? "has-arrow" : ""}>
                <> <i className={`${getPrimaryTextClass()} bx bx-slider`} />
                  <span>{props.t("Tools")}</span>
                </>
              </Link>
              <ul aria-expanded="false">
                <li>
                  <Link to="/settings" className=" ">
                    <>
                      <i className={`${getPrimaryTextClass()} bx bx-wrench`} />
                      <span>{props.t("Settings")}</span>
                    </>
                  </Link>
                </li>
                {
                  (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CLIENTS_TERMS_OF_SERVICE_TAB) && bsh_isAdminUserDetailsPresent()) && (
                    <li>
                      <Link to="/terms_of_services">
                        <>
                          <i className={`${getPrimaryTextClass()} bx bx-receipt`} />
                          <span>{props.t("Terms of Service")}</span>
                        </>
                      </Link>
                    </li>
                  )
                }

                {
                  (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_INTEGRATIONS_INDEX_AND_WORKFLOW)) && integrationPermissions.canView && (
                    <li>
                      <Link to="/integrations">
                        <>
                          <i className={`${getPrimaryTextClass()} bx bx-shape-circle`} />
                          <span>{props.t("Integrations")}</span>
                        </>
                      </Link>
                    </li>
                  )
                }

                {
                  (isFeatureFlagActiveForAccounts(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ACCOUNT_NOTIFICATIONS, current_account)) && (
                    <li>
                      <Link to="/notifications">
                        <>
                          <i className={`${getPrimaryTextClass()} bx bx-bell`} />
                          <span>{props.t("Notifications")}</span>
                        </>
                      </Link>
                    </li>
                  )
                }
              </ul>
            </li>
            <li>
              <Link to="/dashboard" className={props?.rolePermissions ? "has-arrow" : ""}>
                <> <i className={`${getPrimaryTextClass()} bx bx-analyse`} />
                  <span>{props.t("Activity")}</span>
                </>
              </Link>
              <ul aria-expanded="false">
                {props?.rolePermissions?.find(singe_obj => singe_obj.ui_key === UI_PERMISSION_KEY.VIEW_CHANGE_HISTORY)?.isActive && (
                  <li>
                    <Link to="/history" className=" ">
                      <>
                        <i className={`${getPrimaryTextClass()} bx bx-time`} />
                        <span>{props.t("Change History")}</span>
                      </>
                    </Link>
                  </li>
                )}
                {props?.rolePermissions?.find(singe_obj => singe_obj.ui_key === UI_PERMISSION_KEY.EMAIL_ACTIVITY)?.isActive && isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_CLIENT_EMAIL_EVENTS) &&
                  <li>
                    <Link to="/email-activity">
                      <>
                        <i className={`${getPrimaryTextClass()} bx bx-mail-send`} />
                        <span>{props.t("Email Activity")}</span>
                      </>
                    </Link>
                  </li>
                }
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
